import { ClearOutlined as ClearOutlinedIcon, TuneOutlined as TuneOutlinedIcon } from '@mui/icons-material';
import Button from '@mui/material/Button';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

type ApplyFilterButtonProps = {
    readonly disabled: boolean;
};

export const ApplyFilterButton: FunctionComponent<ApplyFilterButtonProps> = ({ disabled }) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <Button disabled={disabled} fullWidth={true} startIcon={<TuneOutlinedIcon />} type="submit" variant="contained">
            {translate('common.filters.apply')}
        </Button>
    );
};

type FilterButtonProps = {
    readonly hasFilters: boolean;
    readonly isDirty: boolean;
    readonly onReset?: () => void;
};

export const FilterButton: FunctionComponent<FilterButtonProps> = ({ hasFilters, isDirty, onReset }) => {
    const { translate } = useContext(ApplicationContext);

    const hasAllFiltersApplied = !isDirty && hasFilters;
    if (hasAllFiltersApplied) {
        return (
            <Button
                color="secondary"
                fullWidth={true}
                startIcon={<ClearOutlinedIcon />}
                variant="contained"
                onClick={onReset}
            >
                {translate('common.reset')}
            </Button>
        );
    }

    return <ApplyFilterButton disabled={!isDirty} />;
};
